import { render, staticRenderFns } from "./GrupoEconomicoManage.vue?vue&type=template&id=51b7e079&scoped=true"
import script from "./GrupoEconomicoManage.vue?vue&type=script&lang=js"
export * from "./GrupoEconomicoManage.vue?vue&type=script&lang=js"
import style0 from "./GrupoEconomicoManage.vue?vue&type=style&index=0&id=51b7e079&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b7e079",
  null
  
)

export default component.exports